import styled from 'styled-components';
import media from '../../../../styles/media.style';

export const ResultListItem = styled.div`
  display: flex;
  padding: 20px;
  align-items: center;
  border-bottom: 1px solid #dfdfdf;
  box-sizing: border-box;
  cursor: pointer;

  ${media.tabletP`
    padding: 30px;
  `};

  &:last-child {
    border-bottom: 0 solid #dfdfdf;
  }

  &.selected {
    background-color: #e6eaed;
    border: 1px solid #9ca1a4;
  }
`;

export const StepInfoWrap = styled.div`
  width: calc(100% - 120px);
  display: block;
  align-items: flex-end;

  ${media.tabletP`
    display: flex;
    width: calc(100% - 150px);
  `};
`;

export const StepTitleWrap = styled.div`
  width: 100%;

  ${media.tabletP`
    width: 47%;
  `};
`;

export const StepPowerWrap = styled.div`
  width: 100%;

  ${media.tabletP`
    width: 53%;
  `};
`;

export const StepImage = styled.div`
  margin-right: 20px;
  position: relative;

  .recommend {
    position: absolute;
    left: -20px;
    top: -30px;
    width: 90px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 1000px;
    background: #e1e1e1;
    color: #000;
    transform: scale(0.7);
    font-size: 11px;
    box-sizing: border-box;
    border: 2px solid #fff;

    ${media.tabletP`
      top: -40px;
    `};
  }
`;
export const ProgramImage = styled.div`
  width: 120px;
  height: 120px;

  ${media.tabletP`
    width: 100px;
    height: 100px;
  `};
`;

export const StepTitle = styled.h2`
  font-size: 14px;
  color: #000;
  line-height: 1.5;

  ${media.tabletP`
    font-size: 20px;
  `};
`;

export const StepProgram = styled.div`
  color: #000;
  font-size: 10px;

  ${media.tabletP`
    font-size: 12px;
  `};

  .title {
    font-weight: bold;
    display: inline-block;
  }
  .caption {
    display: inline-block;
    margin-left: 5px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/DiagnosisResultListCard/DiagnosisResultListCard.style.js